import { createAction, props } from '@ngrx/store';

import { CurrentUser } from '@priva/auth/current-user';

export const loadCurrentUser = createAction('[Current User] Load Current User');

export const loadCurrentUserSuccess = createAction(
    '[Current User] Load Current User Success',
    props<{ currentUser: CurrentUser }>(),
);

export const loadCurrentUserFailure = createAction(
    '[Current User] Load Current User Fail',

    props<{ error: any }>(),
);
